import React, { useEffect, useRef } from "react";

const CustomInput = ({ 
    label, id, name, type = "text", value, onChange, onBlur, error, required, isTextArea, ...rest 
}) => {
    const textareaRef = useRef(null);

    useEffect(() => {
        if (isTextArea && textareaRef.current) {
            textareaRef.current.style.height = "auto";  // Reset height before calculating new height
            textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
        }
    }, [value]);

    return (
        <div className={`custom-form-group ${isTextArea ? 'h-auto' : ''}`}>
            <label htmlFor={id}>{label}</label>

            {isTextArea ? (
                <textarea
                    ref={textareaRef}
                    id={id}
                    name={name}
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    required={required}
                    style={{ minHeight: "50px", overflowY: "hidden", resize: "none", marginTop: "36px" }}
                    {...rest}
                />
            ) : (
                <input
                    type={type}
                    id={id}
                    name={name}
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    required={required}
                    {...rest}
                />
            )}

            {error && <div className="error-text">{error}</div>}
            <hr className={error ? "error-hr-line" : ""} />
        </div>
    );
};

export default CustomInput;
